import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Collapse from '@mui/material/Collapse';
import { styled } from '@mui/material/styles';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

function DetailLink ( { info } )
{
  return (
    <Link to={{
      pathname: "/services/service-detail",
      state: {
        id: info[ 'id' ],
        name: info[ 'product_name' ],
        validity: info[ 'service_validity' ],
        st_date: info[ 'start_date' ],
        ex_date: info[ 'expire_date' ],
      }
    }}
      className={"text-primary"}>
      <span className={"me-2"}>مشاهده</span>
      <span className="svg-icon svg-icon-2 svg-icon-primary">
        <KeyboardBackspaceIcon />
      </span>
    </Link>
  );
}

export default function CollapseUserService ( props )
{
  const [ expanded, setExpanded ] = useState( false );
  const [ data, setData ] = useState( {} );
  const [ column, setColumn ] = useState( [] );
  const handleExpandClick = () =>
  {
    setExpanded( !expanded );
  };
  const ExpandMore = styled( ( props ) =>
  {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  } )( ( { theme, expand } ) => ( {
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create( 'transform', {
      duration: theme.transitions.duration.shortest,
    } ),
  } ) );

  const handleStatusColor = ( status ) =>
  {
    switch ( parseInt( status ) )
    {
      case 1: {
        return 'success';
      }
      case 2: {
        return 'danger';
      }
      case 3: {
        return 'warning';
      }
      default: {
        return 'warning';
      }
    }
  };

  useEffect( () =>
  {
    setData( props?.item );
    setColumn( props?.columns );
  }, [] );

  return (
    <div style={{ borderRadius: '10px', border: expanded ? '1px solid #eee' : '1px solid transparent', margin: '5px' }}>
      <CardActions className="justify-content-between">
        <div
          className="d-flex gap-3 align-items-center"
          onClick={handleExpandClick}
        >
          <Badge
            color={handleStatusColor(data.status)}
            badgeContent=" "
            variant="dot"
          />
          <span>{data.product_name}</span>
          {data.ip && <Chip label={data.ip} size="small" variant="outlined" />}
        </div>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          style={{ marginLeft: 0 }}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse
        sx={{ px: 2 }}
        in={expanded}
        timeout="auto"
        unmountOnExit
      >
        <List>
          {column.map(
            (item) =>
              item.id !== 'ID' && (
                <ListItem
                  key={item.id}
                  disableGutters
                  secondaryAction={
                    <>
                      {(item.id === 'detail' && <DetailLink info={data} />) ||
                        item.label}
                    </>
                  }
                >
                  {item.id !== 'detail' && (
                      <>
                        <ListItemText
                            primary={
                                (data &&
                                    item?.id?.toLowerCase() === 'status' &&
                                    data.status_str) ||
                                (data && data[item?.id?.toLowerCase()]) ||
                                '-'
                            }
                        />
                        {item.id === "label" && (
                            <ListItemText
                                primary={data?.user_label ? data.user_label : "-"}
                            />
                        )}
                      </>
                  )}

                </ListItem>
              )
          )}
        </List>
      </Collapse>
    </div>
  );
}